<template>
  <div class="smartvoice">
    <div v-if="list && list.length > 0">
      <div v-for="item in list"
        :key="item.groupId"
        class="mb10">
        <div class="checkbox radio" :class="{disabled: !item.updateat || !item.defaultVoice}">
          <input type="radio" :id="`smartvoice_${item.groupId}`" :disabled="!item.updateat || !item.defaultVoice" :value="item.groupId" v-model="smartvoice.id">
          <label :for="`smartvoice_${item.groupId}`">{{item.groupName}}</label>
        </div>
        <div v-if="!item.updateat || !item.defaultVoice" class="ml10">
          <div v-if="!item.updateat" class="sysMessage">{{locale.smartvoice_voice_nodata}}</div>
          <div v-if="!item.defaultVoice" class="sysMessage">{{locale.smartvoice_representation_nodata}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartVoice',
  props: [
    'locale',
    'smartvoice'
  ],
  created () {
    this.$store.dispatch('smartvoice/getGroups').then((res) => {
      this.list = res.map(x => x).sort((a, b) => {
        return a.createat > b.createat ? -1 : 1
      })
    })
  },
  data () {
    return {
      list: []
    }
  }
}
</script>
